import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import cookie from 'react-cookies';

const SideNavItem = props => {
    let clickedPath = props.path;
    let toggler = (
        <div role="tab" id={props.id}>
            <a className="list-group-item" href={clickedPath}>{props.name}</a>
        </div>
    );
    let toggledMenu = null;

	const setCookieActionFunctionNo = (functionNo,functionUrl) => {
		  let d = new Date();
		  d.setTime(d.getTime() + (30*60*1000));		
		  cookie.save("RequestFunctionNo", functionNo, {path: "/", expires: d});
	};

    if (props.subList) {
        clickedPath = props.id + 'Collapse';

        toggler = (
            <div role="tab" id={props.id}>
                <a className="list-group-item" data-toggle="collapse" data-parent="#accordion"
                    href={'#' + clickedPath} aria-expanded="true" aria-controls={clickedPath}>
                    {props.name}
                </a>
            </div>
        );

        toggledMenu = (
            <div id={clickedPath} className="panel-collapse collapse " role="tabpanel" aria-labelledby={props.id}>
                <ul className="list-group">
                    {
                        props.subList.map((item, index) => {
                            return <li key={index}> <NavLink className="menu-list" to={item.path} data-toggle="collapse" data-target="#navbar-main" aria-expanded="true" onClick={() => setCookieActionFunctionNo(item.functionNo,item.path)}>{item.name}</NavLink> </li>;
                        })
                    }
                </ul>
            </div>
        )
    }

    return (
        <Fragment>
            {toggler}
            {toggledMenu}
        </Fragment>
    );
}

export default SideNavItem;